import { BespokeField } from '@components/Reservations/orderDetails/types'
import { ApprovaResContact } from '@store/features/types'

// export type DefaultStateType = InitialStateType & { present?: []; past?: []; future?: [] }
export interface Tbooker {
	name?: string
	text?: string
	value: string
	driverId: string
	email: string
	telephone: string
}
export interface DriversType {
	name?: string
	value?: string
	driverId?: string
	dateOfBirth?: string
	email?: string
	exists?: boolean
	title?: string
	firstName?: string
	surname?: string
	emailAddress?: string
	mobilePhoneNumber?: string
	lineManagerFirstName?: string
	lineManagerSurname?: string
	lineManagerEmailAddress?: string
	lineManagerContactNumber?: string
	licenceId?: string
	licenceNumber?: string
	licenceExpiryDate?: string
	licenceIssueDate?: string
	licenceIssueTown?: string
	licenceIssueCountry?: string
	forename?: string
	mobile?: string
	id?: string
	showMessage?: boolean
	workPhoneNumber?: string
	homePhoneNumber?: string
	status?: unknown
	costCentre: null | string
}

export interface InitialStateType {
	emailApprovalValue: 0 | 1
	approvalContactId_all: null | string
	approvalEmailAddress: null | string
	reasonsForHire: { value: string; text: string }[]
	bespokeFieldInfo: BespokeField[]
	resFormSubmit: boolean
	fetchingDriverExists: boolean
	bespokeFieldsValues: object
	enforceInsuranceType: string
	insuranceType: string
	costCentreType: string
	insuranceExpiryTimestamp: null | string
	acceptInsuranceWarning: string
	registerDriversAsUsers: boolean
	canUseUnregisteredDrivers: boolean
	newResForm: NewResFormType
	insuranceTypes: string[] | InsuranceTypes[]
	geoErrorMessage: string
	userPickUpType: string
	userJourneyType: string
	customerInstructions: string
	supplierInstructions: string
	addressSearchResult: null
	deliveryAddressType: null | string
	deliveryAddressId: null | string
	deliveryAddress: null | AddressType
	deliveryLocationInformation: string
	collectionAddressType: null | string
	collectionAddressId: null | string
	collectionAddress: null | AddressType
	collectionLocationInformation: string
	userLocation: UserLocationType
	userHqLocation: {
		latitude: null | number
		longitude: null | number
		name: string
	}
	openingHours: null | OpeningHoursType
	totalDays: number
	startSameAsEnd: boolean
	startAddress: string
	endAddress: string
	supplierBranches: null
	addressesSearchResults: null
	addressCategories: null
	businessVehicleCodesReact: {} | BusinessVehicleCodesReactType
	tariffBand: string
	tariffBandId: null
	applicableTariffBands: ApplicableTariffBandsType[]
	applicableTariffOptions: []
	resStartDate: string
	resStartDateParsed: null | number
	resEndDate: string
	resEndDateParsed: null | number
	resStartTime: string
	resEndTime: string
	currentTariffBandBreakDowns: null
	startLocation: string
	displayFooter: boolean
	resFormSessionKey: string
	currentTariffOOHStatus: null
	driverList: DriverListType[]
	driver: {
		name: string
		email: string
		value: string
	}
	additionalDriverInfo: {
		[key: string]: DriversType
	}
	existingDriver: DriversType
	outOfHours: null | string
	booker: Tbooker
	existingDrivers: {} | ExistingDriversType
	newDrivers: {}
	vehicleGroupId: null | string
	vehicleDetails: VehicleType
	showInsuranceWarning: null | boolean
	clientReference: null | string
	costCentre: null | string
	purchaseOrder: null | string
	countryId?: string
	applicableTariffBandOptions?: ApplicableTariffBandOptionsType[]
	insuranceExpiryDate?: string
	defaultEndDateDays?: number
	minimumEndDateDays?: number
	canBookInPast?: boolean
	mandatoryFields: { [key: string]: string | number }
	bespokeFields: [] | { field: string; value: string }[]
}

export type UserLocationType = {
	latitude: number | null
	longitude: number | null
}

export type ApplicableTariffBandOptionsType = {
	text: string
	value: string
	key: string
	stopgap: boolean
	description: string
	minDays: number
	index: number
}
export interface CurrentTariffBandBreakDowns {
	id: string
	minDays: number
	name: string
	outOfHoursType: string
	stopgap: boolean
	type: string
}

export type ResBusinessDefaultsType = {
	fetchBusinessDefaultsLoading: boolean
	accountNumber: string
	additionalDriverLimit: null | number
	additionalEmailAddressToRecieveConfirmation: string[]
	address: string
	approverValidationType: string
	autoAllocate: number
	bespokeFieldInfo: object[]
	bookerRecievesEmail: boolean
	bookerRecievesSMS: boolean
	businessVehicleCodes: { [key: number]: string }
	businessVehicleCodesReact: BusinessVehicleCodesReactType
	businessVehicleDefault: string | null
	businessVehicleDefaults: { [key: string]: string }
	canBookInPast: boolean
	canUseUnregisteredDrivers: boolean
	countryId: string
	cuiUserSelectTariff: boolean
	currentTariffBandBreakdowns: CurrentTariffBandBreakDowns[]
	currencySymbol: string
	customResRules: string
	customResRulesName: null
	defaultDriverStatusRentalVehicleGroupRestrictions: []
	defaultEndDateDays: number
	disallowDeliveryAndCollection: boolean
	driverLineManagerEmailAddressMandatory: boolean
	driverReceivesEmail: boolean
	driverReceivesSMS: boolean
	enforceInsuranceType: string
	enforcecostCentre: string | null
	gracePeriodForCustomer: string
	hasApprovalGrades: boolean
	hideCUIEditLineManager: boolean
	hideLineManager: boolean
	hideSupplierFromCUI: boolean
	insuranceExpiryDate: string
	insuranceExpiryTimestamp: string
	insuranceType: string[]
	limitDriverAddresses: number
	limitToExistingDrivers: boolean
	lineManagerRequired: boolean
	lockStartDate: boolean
	minimumEndDateDays: number
	notes: null
	orderNumberFormat: string
	pickupType: string
	provecta: boolean
	reasonsForHire: { archivedDateTime: null; id: string; reason: string; value: string; text: string }[]
	reasonForHireRequired: boolean
	showBookerNameOnInvoice: boolean
	specialInstructions: string
	supplierInstructions: null | string
	telephoneNumber: string
	bookerConfirmationShowSalesQuote: number
	hideCustomerInstructions: string
	hideSupplierInstructions: string
	hideCustomerOrderNumber: string
	hidePurchaseOrderNumber: string
	hideCostCentre: string
	insuranceTypeOptions: [InsuranceTypeOptionsValues<'COI'> | InsuranceTypeOptionsValues<'CDW'> | InsuranceTypeOptionsValues<'FDW'>]
	validCostCentre: []
	isQuotesUnavailable: boolean
	selectableGroups:
		| []
		| {
				[key: string]: { class: string; value: string }
		  }
}

type InsuranceTypeOptionsValues<T> = {
	key: T
	text: T
	value: T
}

export type ExistingDriversType = {
	existingDriverTitleFormElement1: null | string
	existingDriverForenameFormElement1: null | string
	existingDriverSurnameFormElement1: null | string
	existingDriverIDFormElement1: null | string
	existingDriverEmailFormElement1: null | string
	existingDriverTelFormElement1: null | string
	existingDriverLineManagerFirstNameFormElement1: null | string
	existingDriverLineManagerSurnameFormElement1: null | string
	existingDriverLineManagerEmailFormElement1: null | string
	existingDriverLineManagerContactNumberFormElement1: null | string
	existingDriverLicenceIDFormElement1: null | string
	existingDriverLicenceNumberFormElement1: null | string
	existingDriverLicenceExpiryDateFormElement1: null | string
	existingDriverLicenceIssueDateFormElement1: null | string
	existingDriverLicenceIssueTownFormElement1: null | string
	existingDriverLicenceIssueCountryFormElement1: null | string
}

export type DriverListType = {
	id: string
	driverId?: string
	forename: string
	title: null | string
	surname: string
	subtext: string
	text: string
	value: string
	email: string
	exists?: boolean
	name: string
	homePhoneNumber?: string
	mobilePhoneNumber?: string
	newDriver?: boolean
}

export type ApplicableTariffBandsType = {
	id: string
	name: string
	type: string
	outOfHoursType: string
	stopgap: boolean
	minDays: number
	driverTariff: number
	paymentEnabled: null | boolean
}

export type BusinessVehicleCodesReactType = {
	[key: string]: VehicleType[]
}

export type VehicleType = {
	id: string
	code: string
	example: string
	isAutomatic: null | string
	airCondition: null | string
	doorCount: string
	co2: string
	seats: string
	luggage: string
	pictureUrl: string | { main: string; other: string[] }
	offPolicy: boolean
	max: string
	min: string
}

export type AddressType = {
	addressType?: string
	supplierName?: string
	id: string
	allocationType?: null | string
	branchId?: string
	lines?: string
	county?: null | string
	postcode?: string
	latitude?: string
	longitude?: string
	supplierCode?: string
	branchName?: string
	sunOpening?: string
	sunClosing?: string
	monOpening?: string
	monClosing?: string
	tueOpening?: string
	tueClosing?: string
	wedOpening?: string
	wedClosing?: string
	thuOpening?: string
	thuClosing?: string
	friOpening?: string
	friClosing?: string
	satOpening?: string
	satClosing?: string
	useOpeningHours?: string
	supplierId?: string
	openingHours?: OpeningOrClosingType[]
	index?: string
	title?: string
	text?: string
	latLong?: undefined
}

export type InsuranceTypes = {
	text: string
	key: string
	value: string
}

export type OpeningHoursType = {
	monToFriOpening: string
	monToFriClosing: string
	satOpening: string
	satClosing: string
	deliveryHours: OpeningOrClosingType[]
	collectionHours: OpeningOrClosingType[]
	currentTariffOOHStatus: string
}

export type OpeningOrClosingType = {
	opening: string
	closing: string
}

export type InitialBookerStateType = {
	name: string
	value: string
	driverId: string
	email: string
	telephone: string
}

export type NewResFormType = {
	operatorBlockIfInsuranceExpired: boolean
	form: {
		id?: string
		action?: string
		method?: string
		name?: string
		formUID?: {
			name: string
			fields: { name: string; value: string; type: string }[]
		}
		process?: string
		reactInputs?: { name: string; value: string | number }[]
		namedInputs?: {
			[key: string]: {}
		}
	}
}

export type HoursType = 'deliveryHours' | 'collectionHours'

export type MergeOpeningHoursAction = {
	type: 'mergeOpeningHours'
	payload: { HoursType: OpeningOrClosingType[] }
}

export type SetOpeningHoursAction = {
	type: 'setOpeningHours'
	payload: OpeningHoursType
}

export type SetBespokeFieldsValuesAction = {
	type: 'setBespokeFieldsValues'
	payload: { name: string; value: string; mandatory: number | null }
}

export type ResetAction = {
	type: 'reset'
}

export type ShowInsuranceWarningAction = {
	type: 'showInsuranceWarning'
	payload: boolean
}

export type SetAcceptInsuranceWarningAction = {
	type: 'setAcceptInsuranceWarning'
	payload: string
}

export type SetClientReferenceAction = {
	type: 'setclientReference'
	payload: string
}

export type SetCostCentreAction = {
	type: 'setcostCentre'
	payload: string
}

export type SetPurchaseOrderAction = {
	type: 'setpurchaseOrder'
	payload: string
}

export type SetRegisterDriversAsUsersAction = {
	type: 'setRegisterDriversAsUsers'
	payload: boolean
}

export type SetInsuranceTypeAction = {
	type: 'setInsuranceType'
	payload: string
}

export type SetNewResFormAction = {
	type: 'setNewResForm'
	payload: NewResFormType
}

export type SetInsuranceTypesAction = {
	type: 'setInsuranceTypes'
	payload: string[]
}

export type SetUserJourneyTypeAction = {
	type: 'setUserJourneyType'
	payload: string
}

export type SetUserPickUpTypeAction = {
	type: 'setUserPickUpType'
	payload: string
}

export type GetGeoErrorMessageAction = {
	type: 'getGeoErrorMessage'
	payload: string
}

export type ClearSelectedAddressAction = {
	type: 'clearSelectedAddress'
	payload: string
}
export type SetApprovals = {
	type: 'setApprovals'
	payload: { contactIds: ApprovaResContact[]; id: string; fieldType: string; fieldValue: string }
}

export type SetStartSameAsEndAction = {
	type: 'setStartSameAsEnd'
	payload: boolean
}

export type SetSelectedAddressAction = {
	type: 'setSelectedAddress'
	payload: { address: AddressType; addressType: string; id: string; latLong: undefined; text: string; title: string; type: string }
}

export type SetSupplierInstructionsAction = {
	type: 'setSupplierInstructions'
	payload: string
}

export type SetCustomerInstructionsAction = {
	type: 'setCustomerInstructions'
	payload: string
}

export type SetBusinessVehicleCodesReactAction = {
	type: 'setBusinessVehicleCodesReact'
	payload: BusinessVehicleCodesReactType
}

export type SetCountryIdAction = {
	type: 'setCountryId'
	payload: string
}

export type SetTariffBandAction = {
	type: 'setTariffBand'
	payload: string
}

export type SetApplicableTariffBands = {
	type: 'setApplicableTariffBands'
	payload: ApplicableTariffBandsType[]
}

export type SetOutOfHoursAction = {
	type: 'setOutOfHours'
	payload: string
}

export type UserLocationAction = {
	type: 'userLocation'
	payload: UserLocationType
}

export type SetResStartDateAction = {
	type: 'setResStartDate'
	payload: Date
}

export type SetResEndDateAction = {
	type: 'setResEndDate'
	payload: Date
}

export type SetResStartTimeAction = {
	type: 'setResStartTime'
	payload: string
}

export type SetResEndTimeAction = {
	type: 'setResEndTime'
	payload: string
}

export type SetTotalDaysAction = {
	type: 'setTotalDays'
	payload: number
}

export type SetVehicleGroupIdAction = {
	type: 'setVehicleGroupId'
	vehicleGroupId: string
	vehicleDetails: VehicleType
}

export type SetDriverListAction = {
	type: 'setDriverList'
	driverList: DriverListType[]
}

export type UpdateDriverFormElementsAction = {
	type: 'updateDriverFormElements'
	payload: { selectedDrivers: DriversType[]; singleDriverData: DriversType }
}

export type SetBookerAction = {
	type: 'setBooker'
	booker: InitialBookerStateType
}

export type SetResBusinessDefaultsAction = {
	type: 'setResBusinessDefaults'
	payload: ResBusinessDefaultsType
}
export type SetFetchingDriver = {
	type: 'FETCHING_DRIVER_EXISTS'
	payload: boolean
}

export type ClearDriver = {
	type: 'clearDriver'
}

export type ResFormContextDispatchActions =
	| SetFetchingDriver
	| MergeOpeningHoursAction
	| SetOpeningHoursAction
	| SetBespokeFieldsValuesAction
	| ResetAction
	| ShowInsuranceWarningAction
	| SetAcceptInsuranceWarningAction
	| SetClientReferenceAction
	| SetCostCentreAction
	| SetPurchaseOrderAction
	| SetRegisterDriversAsUsersAction
	| SetInsuranceTypeAction
	| SetNewResFormAction
	| SetInsuranceTypesAction
	| SetUserJourneyTypeAction
	| SetUserPickUpTypeAction
	| GetGeoErrorMessageAction
	| ClearSelectedAddressAction
	| SetStartSameAsEndAction
	| SetSelectedAddressAction
	| SetSupplierInstructionsAction
	| SetCustomerInstructionsAction
	| SetBusinessVehicleCodesReactAction
	| SetCountryIdAction
	| SetTariffBandAction
	| SetApplicableTariffBands
	| SetOutOfHoursAction
	| UserLocationAction
	| SetResStartDateAction
	| SetResEndDateAction
	| SetResStartTimeAction
	| SetResEndTimeAction
	| SetTotalDaysAction
	| SetVehicleGroupIdAction
	| SetDriverListAction
	| UpdateDriverFormElementsAction
	| SetBookerAction
	| SetApprovals
	| SetResBusinessDefaultsAction
	| ClearDriver
